(function () {
  var HOST_SELECTOR = '.section-apps--page-form';
  var EMBED_SELECTOR = HOST_SELECTOR + ' shopify-forms-embed, ' + HOST_SELECTOR + ' form-embed';
  var STYLE_ID = 'page-form-two-col';
  var GRID_HOST_CLASS = 'page-form-grid-host';
  var SLOT_ATTR = 'data-page-form-slot';
  var FORM_WIDTH = '1020px';
  var DESKTOP = '(min-width: 769px)';

  var CSS =
    '@media (min-width: 769px) {' +
    'section[data-testid="form-container"], [class*="_inline_"], [class*="_formContainer_"] {' +
    '  max-width: ' + FORM_WIDTH + ' !important;' +
    '  width: 100% !important;' +
    '  margin-left: auto !important;' +
    '  margin-right: auto !important;' +
    '}' +
    '.' + GRID_HOST_CLASS + ' {' +
    '  display: grid !important;' +
    '  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;' +
    '  column-gap: 36px !important;' +
    '  row-gap: 24px !important;' +
    '  justify-items: stretch !important;' +
    '  align-items: start !important;' +
    '  max-width: ' + FORM_WIDTH + ' !important;' +
    '  width: 100% !important;' +
    '  margin-left: auto !important;' +
    '  margin-right: auto !important;' +
    '  box-sizing: border-box !important;' +
    '}' +
    '.' + GRID_HOST_CLASS + ' > [' + SLOT_ATTR + '] {' +
    '  width: 100% !important;' +
    '  max-width: 100% !important;' +
    '  min-width: 0 !important;' +
    '  justify-self: stretch !important;' +
    '  box-sizing: border-box !important;' +
    '}' +
    '.' + GRID_HOST_CLASS + ' input[type="text"],' +
    '.' + GRID_HOST_CLASS + ' input[type="email"],' +
    '.' + GRID_HOST_CLASS + ' textarea {' +
    '  box-sizing: border-box !important;' +
    '  max-width: 100% !important;' +
    '  width: 100% !important;' +
    '}' +
  '.' + GRID_HOST_CLASS + ' > [' + SLOT_ATTR + '="full"] {' +
    '  grid-column: 1 / -1 !important;' +
    '}' +
    '.' + GRID_HOST_CLASS + ' > [' + SLOT_ATTR + '="submit"] {' +
    '  grid-column: 1 / -1 !important;' +
    '  justify-self: center !important;' +
    '  width: auto !important;' +
    '}' +
    'button[type="submit"] { min-width: 220px !important; }' +
    '}';

  function isScopedEmbed(embed) {
    return !!embed.closest(HOST_SELECTOR);
  }

  function injectStyles(embed) {
    if (!embed.shadowRoot) return;

    var existing = embed.shadowRoot.getElementById(STYLE_ID);
    if (existing) {
      existing.textContent = CSS;
      return;
    }

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    embed.shadowRoot.appendChild(style);
  }

  function isPhoneWrapper(el) {
    if (!el.querySelector('input[type="tel"]')) return false;
    return el.querySelectorAll('input:not([type="hidden"])').length <= 2;
  }

  function findFieldWrapper(input, root) {
    var el = input;
    var best = input.parentElement || input;

    while (el && el !== root) {
      var count = el.querySelectorAll('input:not([type="hidden"]), textarea, select').length;
      if (count === 1 || isPhoneWrapper(el)) {
        best = el;
      } else if (count > 1 && !isPhoneWrapper(el)) {
        break;
      }
      el = el.parentElement;
    }

    return best;
  }

  function mapFields(form) {
    var emailInput = form.querySelector('input[type="email"]');
    var phoneInput = form.querySelector('input[type="tel"]');
    var messageInput = form.querySelector('textarea');

    var emailWrap = emailInput ? findFieldWrapper(emailInput, form) : null;
    var phoneWrap = phoneInput ? findFieldWrapper(phoneInput, form) : null;
    var messageWrap = messageInput ? findFieldWrapper(messageInput, form) : null;
    var nameInput = null;

    form.querySelectorAll('input').forEach(function (input) {
      var type = (input.getAttribute('type') || 'text').toLowerCase();
      if (
        type === 'hidden' ||
        type === 'email' ||
        type === 'tel' ||
        type === 'checkbox' ||
        type === 'radio' ||
        type === 'submit'
      ) {
        return;
      }
      if (emailWrap && emailWrap.contains(input)) return;
      if (phoneWrap && phoneWrap.contains(input)) return;
      if (messageWrap && messageWrap.contains(input)) return;
      if (!nameInput) nameInput = input;
    });

    return {
      name: nameInput ? findFieldWrapper(nameInput, form) : null,
      email: emailWrap,
      phone: phoneWrap,
      message: messageWrap
    };
  }

  function directChildOf(host, node) {
    var el = node;
    while (el && el.parentElement !== host) {
      el = el.parentElement;
      if (!el || el === document) return null;
    }
    return el && el.parentElement === host ? el : null;
  }

  function findGridHost(form, wrappers) {
    var nodes = wrappers.filter(Boolean);
    if (!nodes.length) return null;

    var seen = [];
    nodes.forEach(function (wrapper) {
      var el = wrapper;
      while (el && el !== form) {
        if (seen.indexOf(el) === -1) seen.push(el);
        el = el.parentElement;
      }
    });

    seen.push(form);
    seen.sort(function (a, b) {
      var da = 0;
      var db = 0;
      var n = a;
      while (n) { da++; n = n.parentElement; }
      n = b;
      while (n) { db++; n = n.parentElement; }
      return db - da;
    });

    for (var i = 0; i < seen.length; i++) {
      var host = seen[i];
      var direct = nodes.map(function (wrapper) {
        return directChildOf(host, wrapper);
      });
      if (direct.every(Boolean) && new Set(direct).size === direct.length) {
        return host;
      }
    }

    return null;
  }

  function resetNode(el) {
    if (!el) return;
    el.removeAttribute(SLOT_ATTR);
    ['grid-column', 'grid-row', 'width', 'max-width', 'min-width', 'justify-self', 'display'].forEach(function (prop) {
      el.style.removeProperty(prop);
    });
  }

  function clearLayout(root) {
    root.querySelectorAll('[' + SLOT_ATTR + ']').forEach(resetNode);
    root.querySelectorAll('.' + GRID_HOST_CLASS).forEach(function (host) {
      host.classList.remove(GRID_HOST_CLASS);
    });
  }

  function placeField(host, wrapper, slot, col, row) {
    var node = directChildOf(host, wrapper);
    if (!node) return null;

    node.setAttribute(SLOT_ATTR, slot);
    node.style.setProperty('grid-column', String(col), 'important');
    node.style.setProperty('grid-row', String(row), 'important');
    node.style.setProperty('width', '100%', 'important');
    node.style.setProperty('max-width', '100%', 'important');
    node.style.setProperty('min-width', '0', 'important');
    node.style.setProperty('justify-self', 'stretch', 'important');
    return node;
  }

  function applyLayout(root) {
    if (!window.matchMedia(DESKTOP).matches) {
      clearLayout(root);
      return;
    }

    var form = root.querySelector('form');
    if (!form) return;

    clearLayout(root);

    var fields = mapFields(form);
    if (!fields.name || !fields.email || !fields.phone || !fields.message) return;

    var wrappers = [fields.name, fields.email, fields.phone, fields.message];
    var host = findGridHost(form, wrappers);
    if (!host) return;

    host.classList.add(GRID_HOST_CLASS);

    var placed = [
      placeField(host, fields.name, 'name', 1, 1),
      placeField(host, fields.phone, 'phone', 2, 1),
      placeField(host, fields.email, 'email', 1, 2),
      placeField(host, fields.message, 'message', 2, 2)
    ].filter(Boolean);

    Array.from(host.children).forEach(function (child) {
      if (placed.indexOf(child) !== -1) return;
      var slot = child.querySelector('button[type="submit"], [type="submit"]') ? 'submit' : 'full';
      child.setAttribute(SLOT_ATTR, slot);
      child.style.setProperty('grid-column', '1 / -1', 'important');
      child.style.removeProperty('grid-row');
      if (slot === 'submit') {
        child.style.setProperty('justify-self', 'center', 'important');
        child.style.setProperty('width', 'auto', 'important');
      }
    });
  }

  function processEmbed(embed) {
    if (!isScopedEmbed(embed) || !embed.shadowRoot) return;
    injectStyles(embed);
    applyLayout(embed.shadowRoot);
  }

  function init() {
    if (!document.querySelector(HOST_SELECTOR)) return;
    document.querySelectorAll(EMBED_SELECTOR).forEach(processEmbed);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  [200, 500, 1000, 2000, 4000, 8000].forEach(function (ms) {
    setTimeout(init, ms);
  });

  window.addEventListener('resize', init);

  new MutationObserver(init).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
